/**
 * 이름을 마스킹 처리합니다.
 * 2글자: 성+* (예: 홍*)
 * 3글자 이상: 첫 글자 + 나머지 * (예: 홍*동 또는 홍**동)
 */
export const maskName = (name: string | null | undefined): string => {
  if (!name) return "익명";

  const trimmedName = name.trim();
  if (trimmedName.length === 0) return "익명";

  if (trimmedName.length === 1) {
    return trimmedName;
  }

  if (trimmedName.length === 2) {
    return `${trimmedName[0]}*`;
  }

  // 3글자 이상
  const firstChar = trimmedName[0];
  const lastChar = trimmedName[trimmedName.length - 1];
  const middleStars = "*".repeat(trimmedName.length - 2);

  return `${firstChar}${middleStars}${lastChar}`;
};
